module.exports = __webpack_public_path__ + "static/3-f7652576445788d57329f786381e842a.png";